
export default {
  computed: {
    locais() {
      return [
        {
          icon: "mdi-map-marker-path",
          text: this.cep,
          title: "CEP"
        },
        {
          icon: "mdi-home-group",
          text: this.rua,
          title: "Rua"
        },
        {
          icon: "mdi-home-floor-1",
          text: this.numero,
          title: "Número"
        },
        {
          icon: "mdi-home",
          text: this.complemento || '--',
          title: "Complemento"
        },
        {
          icon: "mdi-city-variant",
          text: this.cidade,
          title: "Cidade"
        },
        {
          icon: "mdi-home-city",
          text: this.bairro,
          title: "Bairro"
        }
      ];
    }
  },

  props: {
    cep: String,
    rua: String,
    numero: String,
    complemento: String,
    cidade: String,
    bairro: String
  }
};

